import { toast } from 'sonner';

const UPDATE_INTERVAL = 5 * 60 * 1000;
const MIN_CHECK_INTERVAL = 30 * 1000;

/** Keep the current replay/editor open; let the user choose when to reload. */
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  let controller = navigator.serviceWorker.controller;
  // Listen before registering: activation can happen during registration, or in another tab.
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    const nextController = navigator.serviceWorker.controller;
    if (controller && nextController && nextController !== controller) {
      toast('A new version of BallCam is ready', {
        id: 'app-update',
        description: 'Update when you are ready to reload this page.',
        duration: Infinity,
        action: { label: 'Update', onClick: () => window.location.reload() },
      });
    }
    controller = nextController;
  });

  void navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`, {
    scope: import.meta.env.BASE_URL,
    updateViaCache: 'none',
  }).then(registration => {
    let checking = false;
    let lastCheck = 0;
    const checkForUpdate = async () => {
      if (!navigator.onLine || document.visibilityState !== 'visible'
        || registration.installing || checking || Date.now() - lastCheck < MIN_CHECK_INTERVAL) return;

      checking = true;
      lastCheck = Date.now();
      try {
        await registration.update();
      } catch {
        // A failed request must not break playback; retry on the next check.
      } finally {
        checking = false;
      }
    };

    // Registration already checks on page load. Also check when the app resumes.
    window.addEventListener('focus', checkForUpdate);
    document.addEventListener('visibilitychange', checkForUpdate);
    window.addEventListener('online', () => {
      lastCheck = 0;
      void checkForUpdate();
    });
    window.setInterval(checkForUpdate, UPDATE_INTERVAL);
  }).catch(error => {
    console.warn('Could not register the service worker:', error);
  });
}
